/* eslint-disable jsdoc/check-param-names */
import { ActionBrick, registerBrick, BrickContext } from 'olympe';
import { getLogger } from '@olympeio/core';

export default class WBSSearchMapping extends ActionBrick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string[]} pRNNumbers
     * @param {string[]} pRNByWBS
     * @param {string[]} pRNByInternal
     * @param {string[]} approvers
     * @param {string} agents
     * @param {function(): void} forwardEvent
     * @param {function(string): void} setFilterString
     */
    update($, [pRNNumbers, pRNByWBS, pRNByInternal, approvers, agents], [forwardEvent, setFilterString]) {
        const logger = getLogger('WBSSearchMapping');
        try {
            const filter = [`IdNo eq '02'`];
            const prnFilterList = [];
            const approverFilterList = [];

            if (pRNNumbers?.length > 0) {
                pRNNumbers.forEach((pRNNumber) => {
                    prnFilterList.push(`CostElementId eq '${pRNNumber}'`);
                });
            }

            if (pRNByWBS?.length > 0) {
                pRNByWBS.forEach((pRNNumber) => {
                    prnFilterList.push(`CostElementId eq '${pRNNumber}'`);
                });
            }

            if (pRNByInternal?.length > 0) {
                pRNByInternal.forEach((pRNNumber) => {
                    prnFilterList.push(`CostElementId eq '${pRNNumber}'`);
                });
            }

            if (pRNNumbers?.length > 0 || pRNByWBS?.length > 0 || pRNByInternal?.length > 0) {
                const wbsFilter = prnFilterList.join(' or ');
                filter.push(`(${wbsFilter})`);
            }

            if (approvers?.length > 0) {
                approvers.forEach((approver) => {
                    approverFilterList.push(`SearchTerm eq '${approver}'`);
                });
            }

            if (agents?.length > 0) {
                agents.forEach((agent) => {
                    approverFilterList.push(`SearchTerm eq '${agent}'`);
                });
            }

            if (approvers?.length > 0 || agents?.length > 0) {
                const approverFilter = approverFilterList.join(' or ');
                filter.push(`(${approverFilter})`);
            }

            const returnFilterString = `${filter.join(' and ')}`;

            setFilterString(returnFilterString);
            forwardEvent();
        } catch (error) {
            const message = typeof error === 'string' ? error : error.message;
            logger.error(message);
        }
    }
}

registerBrick('01905e4d7525a55df979', WBSSearchMapping);
